<!-- eslint-disable vue/no-parsing-error -->
<!-- eslint-disable vue/valid-v-bind -->
<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="3"
          lg="2"
        >
          <documentTabs />
        </b-col>
        <b-col
          cols="12"
          md="9"
          lg="10"
        >
          <router-view />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-card class="text-center">
          <b-button
            variant="primary"
            pill
            style="width: 300px;"
            @click="termsModal = true"
          >
            <span
              style="font-size:small;"
            >{{ $t('Agreement_register_page.terms').toUpperCase() }}</span>
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="termsModal"
      :title="$t('Agreement_register_page.terms').toUpperCase()"
      size="lg"
      hide-footer
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <div
        dir="ltr"
        style="text-align: left;"
        v-html="termsText"
      />

    </b-modal>
  </div>
</template>
<script>

import Document from '@/views/logics/documents/Document'
import documentTabs from './documentTabs.vue'

export default {
  components: {
    documentTabs,
  },
  mixins: [Document],
}
</script>

<style scoped lang="scss">
::v-deep .modal-title {
 color: white;
}
</style>
